import React from 'react';
import ReactDOM from 'react-dom';
// Redux
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import App from './App';
import rootReducer from './rootReducer';

import 'typeface-inter';

// TODO: temporarily disabled due to typescript error
// Enable redux dev tools
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

const store = createStore(rootReducer, compose(applyMiddleware(thunk)));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
